import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { PermissionService, UserService } from '.';

import * as _ from 'lodash';

@Injectable({ providedIn: 'root' })
export class RoleGuard implements CanActivate {
    constructor(private router:Router, private permissionService: PermissionService, private userService:UserService) { }

    canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const roles = route.data["roles"] as Array<string>;
        
        return this.userService.isLoggedIn()
        .pipe(
            map(response => {
                const isAllowed = response.user &&
                _.reduce(roles, (currentVal, action) => currentVal && this.permissionService.userHasPermission(response.user, { action }), true)
                if (!isAllowed) {
                    this.router.navigate(['/']);
                }
                return isAllowed;
            })
        );
    };
}
